import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  IconButton,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from "@mui/material";
import SwitchToggle from "../../../components/SwitchToggle";
import BookService from "../../../Modals/bookService";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel({ children, value, index, ...other }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ViewService = () => {
  const navigate = useNavigate();

  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const portfolioItems = [
    {
      id: 1,
      thumbnail: "/static/images/placeholder.png",
      title: "Travel Blog Article",
      category: "Content Writing",
      subCategory: "Blog Writing",
      description:
        "A well-researched and SEO-optimized travel guide for UAE tourists.",
    },
    {
      id: 2,
      thumbnail: "/static/images/placeholder.png",
      title: "Product Description Set",
      category: "Copywriting",
      subCategory: "E-commerce",
      description:
        "Compelling product descriptions for an online fashion store.",
    },
    {
      id: 3,
      thumbnail: "/static/images/placeholder.png",
      title: "Business Landing Page Copy",
      category: "Web Content",
      subCategory: "Landing Page",
      description: "High-converting landing page copy for a startup website.",
    },
  ];

  return (
    <>
      <div className="main_title">
        <h1>Service Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/services")}>Services</button> -
          Service Detail
        </p>
      </div>
      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              className="custom_tabs_links"
            >
              <Tab label="Service Details" {...a11yProps(0)} />
              <Tab label="Portfolio" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>
      {/* Personal Info */}
      <CustomTabPanel value={valueTabs} index={0}>
        <div className="cards view_page">
          <div className="provider-card">
            <div className="provider-icon">
              <img src="/static/images/placeholder.png" alt="" />
            </div>

            <div className="provider-content">
              <div className="provider-row">
                <h6>Service Provider Name</h6>
                <p>Content Writers UAE</p>
              </div>

              <div className="provider-row">
                <h6>About</h6>
                <p>
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Corporis quos dolore vel vitae repellendus sunt reiciendis.
                </p>
              </div>

              <div className="provider-row">
                <h6>Rating & Reviews</h6>
                <p>⭐ 4.9 (153 reviews)</p>
              </div>
            </div>
          </div>
        </div>
        <div className="cards mt_20">
          <div className="title_inner">
            <h3>Available Services</h3>
          </div>
          <div className="book_service">
            <div className="book_inner">
              <figure>
                <img src="/static/images/placeholder.png" alt="icon" />
              </figure>
              <h3>Product Description Bundle (20 Items)</h3>
              <p>
                High-quality English & Arabic product descriptions crafted to
                boost conversions and improve SEO ranking.
              </p>
              <div className="time">
                <p>2 days delivery</p>
                <h4 className="price">AED 250</h4>
              </div>
              <Button
                className="btn btn_grey sm"
                onClick={() => navigate("/my-orders/view")}
              >
                View Service
              </Button>
              <Button
                className="btn btn_primary sm" style={{ marginTop: "10px" }}
                onClick={() => setOpenModal(true)}
              >
                Book This Service
              </Button>
            </div>
            <div className="book_inner">
              <figure>
                <img src="/static/images/placeholder.png" alt="icon" />
              </figure>
              <h3>Monthly Blog Writing (12 Blogs)</h3>
              <p>
                Professionally researched and SEO-optimized blogs to increase
                organic traffic and strengthen brand authority.
              </p>
              <div className="time">
                <p>7 days delivery</p>
                <h4 className="price">AED 850</h4>
              </div>
              <Button
                className="btn btn_grey sm "
                onClick={() => navigate("/my-orders/view")}
              >
                View Service
              </Button>
              <Button
                className="btn btn_primary sm" style={{ marginTop: "10px" }}

                onClick={() => setOpenModal(true)}
              >
                Book This Service
              </Button>
            </div>
            <div className="book_inner">
              <figure>
                <img src="/static/images/placeholder.png" alt="icon" />
              </figure>
              <h3>Social Media Captions Package (40 Captions)</h3>
              <p>
                Creative, engaging captions for Facebook, Instagram & TikTok
                written to increase engagement and impressions.
              </p>
              <div className="time">
                <p>3 days delivery</p>
                <h4 className="price">AED 180</h4>
              </div>
              <Button
                className="btn btn_grey sm "
                onClick={() => navigate("/my-orders/view")}
              >
                View Service
              </Button>
              <Button
                className="btn btn_primary sm" style={{ marginTop: "10px" }}

                onClick={() => setOpenModal(true)}
              >
                Book This Service
              </Button>
            </div>
            <div className="book_inner">
              <figure>
                <img src="/static/images/placeholder.png" alt="icon" />
              </figure>
              <h3>Website Content (5 Pages)</h3>
              <p>
                Professional content for Home, About, Services, Contact & more —
                fully SEO-ready and brand-aligned.
              </p>
              <div className="time">
                <p>5 days delivery</p>
                <h4 className="price">AED 700</h4>
              </div>
              <Button
                className="btn btn_grey sm "
                onClick={() => navigate("/my-orders/view")}
              >
                View Service
              </Button>
              <Button
                className="btn btn_primary sm" style={{ marginTop: "10px" }}

                onClick={() => setOpenModal(true)}
              >
                Book This Service
              </Button>
            </div>
            <div className="book_inner">
              <figure>
                <img src="/static/images/placeholder.png" alt="icon" />
              </figure>
              <h3>Ad Copywriting Package (10 Ads)</h3>
              <p>
                High-converting ad copies for Google, Meta, and TikTok — crafted
                to maximize CTR and customer acquisition.
              </p>
              <div className="time">
                <p>1 day delivery</p>
                <h4 className="price">AED 150</h4>
              </div>
              <Button
                className="btn btn_grey sm "
                onClick={() => navigate("/my-orders/view")}
              >
                View Service
              </Button>
              <Button
                className="btn btn_primary sm" style={{ marginTop: "10px" }}

                onClick={() => setOpenModal(true)}
              >
                Book This Service
              </Button>
            </div>
          </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs} index={1}>
      
          <div className="cards portfolio_grid">
            {portfolioItems.map((item) => (
              <div className="portfolio_card" onClick={() => navigate("/services/view-work")} key={item.id}>

                {/* Thumbnail */}
                <div className="portfolio_thumb">
                  <img src={item.thumbnail} alt={item.title} />
                </div>

                {/* Content */}
                <div className="portfolio_body">
                  <h3 className="portfolio_title">{item.title}</h3>

                  <div className="portfolio_meta">
                    <span>{item.category}</span>
                    <span>•</span>
                    <span>{item.subCategory}</span>
                  </div>

                  <p className="portfolio_desc">
                    {item.description}
                  </p>
                </div>

                {/* Action */}
                {/* <div className="portfolio_action">
                  <IconButton >
                    <img src="/static/images/eye_icon.svg" alt="View" />
                  </IconButton>
                </div> */}

              </div>
            ))}
          </div>

      
      </CustomTabPanel>

      {/* Add Reply Modal */}
      <BookService
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ViewService;
